export const MAX_SAMPLES_PER_PACK = 300
